import React from 'react';
import { connect } from 'react-redux';
import { makeStyles } from '@material-ui/core/styles';

import { injectIntl } from 'react-intl';
import { Snackbar } from '../components';
import Main from './components/Main';
import Header from './components/Header';
import CalendarLoading from './components/CalendarLoading';

import {
  Portlet,
  PortletBody,
  PortletHeader
} from '../../../_metronic/partials/content/Portlet';

const useStyles = makeStyles((theme) => ({
  root: {
    width: '65%',
    margin: 'auto',
    [theme.breakpoints.down(1670)]: {
      width: '75%'
    },
    [theme.breakpoints.down(1500)]: {
      width: '85%'
    },
    [theme.breakpoints.down(1350)]: {
      width: '100%'
    },
  },
}));

const Schedule = ({
  intl,
  responseMessage,
  responseStatus,
  data,
  listOfYears,
  fetchState
}) => {
  const classes = useStyles();
  const isSendRequest = fetchState === 'send-request';

  return (
    <div className={classes.root}>
      <Snackbar
        message={responseMessage}
        status={responseStatus}
      />
      <Portlet>
        <PortletHeader title={intl.formatMessage({ id: 'SCHEDULE.HEADER.TITLE' })} />
        <PortletBody className="pt-0">
          <Header />
        </PortletBody>
      </Portlet>
      <Portlet>
        <PortletHeader title={intl.formatMessage({ id: 'GENERAL.CALENDAR' })} />
        <PortletBody>
          {
          // eslint-disable-next-line no-nested-ternary
          isSendRequest ? <CalendarLoading /> : listOfYears.length
            ? (
              <Main
                data={data}
                years={listOfYears}
                fetchState={fetchState}
              />
            )
            : null
          }
        </PortletBody>
      </Portlet>
    </div>
  );
};

const mapStateToProps = (store) => ({
  responseMessage: store.schedule.responseMessage,
  responseStatus: store.schedule.responseStatus,
  fetchState: store.schedule.fetchState,
  data: store.schedule.data,
  listOfYears: store.schedule.years,
});

export default injectIntl(connect(mapStateToProps, null)(Schedule));
